/* ============================================================
   PATICO BOX · Logica de la landing
   assets/patico-box.js
   Motor de precios + quiz + toggle mensual/anual + FAQ.
   ============================================================ */

function paticoBoxInit(){
  var root=document.getElementById('pb-top'); if(!root) return;

  /* ---------- MOTOR DE PRECIOS ----------
     Todo se calcula desde: precio mensual, % de descuento, envío y meses del anual.
     Cambias un ajuste en el personalizador y la página entera se recalcula sola. */
  var grid=root.querySelector('.pb__plans');
  if(grid){
    var envio  = parseFloat(grid.getAttribute('data-envio'))  || 0;
    var meses  = parseFloat(grid.getAttribute('data-meses'))  || 10;
    var cop = function(n){ return '$' + Math.round(n).toLocaleString('es-CO'); };

    grid.querySelectorAll('.pb__plan').forEach(function(card){
      var precio = parseFloat(card.getAttribute('data-precio')) || 0;
      var desc   = parseFloat(card.getAttribute('data-desc'))   || 0;
      var gratis = card.getAttribute('data-envio-gratis') === 'true';
      var factor = (100 - desc) / 100;           /* lo que pagas del catálogo */
      var credito = factor > 0 ? precio / factor : 0;
      var per100  = factor > 0 ? 100 / factor : 0;
      var anual   = precio * meses;
      var set = function(k, v){
        card.querySelectorAll('[data-f="'+k+'"]').forEach(function(el){ el.textContent = v; });
      };
      set('mes', cop(precio));
      set('anual', cop(anual));
      set('anualmes', 'Equivale a ' + cop(anual/12) + ' al mes');
      set('credito', '~' + cop(credito));
      set('desc', desc + '%');
      set('per100', cop(per100));

      var shipEl = card.querySelector('[data-f="ship"]');
      if(shipEl){
        if(gratis){
          shipEl.innerHTML = 'Envío gratis · <b>' + cop(precio/30) + ' al día</b>';
        } else {
          shipEl.innerHTML = '+ ' + cop(envio) + ' de envío · <b>' + cop(precio+envio) + ' al mes</b>';
        }
      }
    });
  }

  /* ---------- QUIZ ---------- */
  var score=0, step=0;
  var qs=root.querySelectorAll('.pb__q'), bars=root.querySelectorAll('.pb__prog i'),
      res=root.querySelector('.pb__res');

  var PLANS={
    starter:{n:'Starter Box',c:'$234.000',w:'Con ese ritmo te alcanza de sobra con el crédito más pequeño. Si luego te queda corto, subes de plan cuando quieras.'},
    full:{n:'Full Box',c:'$367.000',w:'Con ese ritmo necesitas alrededor de $367.000 en producto al mes. Esa es la Full, y además te ahorras el envío.'},
    premium:{n:'Premium Box',c:'$641.000',w:'Con ese consumo el crédito pequeño se te acaba a mitad de mes. La Premium te da $641.000 en producto y el mejor descuento.'}
  };

  function show(i){
    qs.forEach(function(q,k){ q.classList.toggle('is-on', k===i); });
    bars.forEach(function(b,k){ b.classList.toggle('on', k<=i); });
  }

  root.querySelectorAll('.pb__opt').forEach(function(btn){
    btn.addEventListener('click', function(){
      score += parseInt(btn.getAttribute('data-v'),10) || 0;
      step++;
      if(step < qs.length){ show(step); }
      else{
        var key = score<=4 ? 'starter' : (score<=8 ? 'full' : 'premium');
        var p = PLANS[key];
        qs.forEach(function(q){ q.classList.remove('is-on'); });
        bars.forEach(function(b){ b.classList.add('on'); });
        document.getElementById('pb-res-name').textContent = p.n;
        document.getElementById('pb-res-why').textContent = p.w;
        res.classList.add('is-on');
        root.querySelectorAll('.pb__plan').forEach(function(el){
          var isIt = el.getAttribute('data-plan')===key;
          var old = el.querySelector('.pb__tag--quiz');
          if(old) old.remove();
          if(isIt){
            var t=document.createElement('div');
            t.className='pb__tag pb__tag--quiz';
            t.textContent='Tu resultado';
            el.appendChild(t);
            el.style.borderColor='var(--gold)';
            el.style.borderWidth='2px';
            el.style.borderStyle='solid';
          }
        });
      }
    });
  });

  var rs=root.querySelector('.pb__restart');
  if(rs) rs.addEventListener('click',function(){
    score=0; step=0; res.classList.remove('is-on'); show(0);
  });

  /* ---------- TOGGLE MENSUAL / ANUAL ---------- */
  var note=document.getElementById('pb-save');
  root.querySelectorAll('.pb__tg').forEach(function(tg){
    tg.addEventListener('click',function(){
      var mode=tg.getAttribute('data-mode');
      root.querySelectorAll('.pb__tg').forEach(function(x){ x.classList.toggle('on', x===tg); });
      root.querySelectorAll('.pb__pm').forEach(function(el){
        el.classList.toggle('on', el.getAttribute('data-m')===mode);
      });
      note.textContent = mode==='a' ? 'Pagas 10 meses y recibes 12.' : '';
    });
  });

  /* ---------- FAQ ---------- */
  root.querySelectorAll('.pb__fq button').forEach(function(b){
    b.addEventListener('click',function(){ b.parentNode.classList.toggle('on'); });
  });
}

if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded', paticoBoxInit);
} else {
  paticoBoxInit();
}
/* Reinicia al editar la seccion en el personalizador de Shopify */
document.addEventListener('shopify:section:load', paticoBoxInit);
